<template>
  <footer class="footer py-5">
    <div class="container">
      <div class="row text-center text-md-start align-items-center">
        <!-- Logo -->
        <div class="col-md-4 mb-3 mb-md-0">
          <img 
            src="../assets/images/logo-gym-removebg-preview.png" 
            alt="Victoria Gym Logo" 
            class="footer-logo-img fade-in"
          />
          <p class="footer-slogan mt-2 fade-in" style="animation-delay: 0.2s;">
            Entrena tu cuerpo y tu mentalidad de victoria.
          </p>
        </div>

        <!-- Enlaces rápidos -->
<div class="col-md-4 mb-3 mb-md-0">
  <h5 class="footer-title fade-in" style="animation-delay: 0.3s;">Enlaces rápidos</h5>
  <ul class="list-unstyled fade-in" style="animation-delay: 0.4s;">
    <li>
      <RouterLink to="/" class="footer-link">
        <i :class="['bi', 'bi-house-door', 'me-2']"></i> Inicio
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/PasesLibres" class="footer-link">
        <i :class="['bi', 'bi-card-checklist', 'me-2']"></i> Pases Libres
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/PlanesView" class="footer-link">
        <i :class="['bi', 'bi-graph-up', 'me-2']"></i> Planes
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/ServiciosView" class="footer-link">
        <i :class="['bi', 'bi-tools', 'me-2']"></i> Servicios
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/RutinasView" class="footer-link">
        <i :class="['bi', 'bi-list-task', 'me-2']"></i> Rutinas
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/ContactanosView" class="footer-link">
        <i :class="['bi', 'bi-envelope-fill', 'me-2']"></i> Contáctanos
      </RouterLink>
    </li>
  </ul>
</div>



        <!-- Redes sociales -->
       <div class="col-md-4 fade-in" style="animation-delay: 0.5s;">
  <h5 class="footer-title">Síguenos</h5>
  <div class="footer-icons">
    <a 
      href="https://wa.me/584143516746" 
      class="footer-icon" 
      target="_blank" 
      rel="noopener noreferrer"
    >
      <i :class="['bi', 'bi-whatsapp', 'me-2']"></i>
    </a>

 <a 
      href="https://www.instagram.com/victoriafitnesscenter/?hl=es" 
      class="footer-icon" 
      target="_blank" 
      rel="noopener noreferrer"
    >
      <i :class="['bi', 'bi-instagram', 'me-2']"></i>
    </a>

    <a href="https://www.tiktok.com/@victoriafitnesscenterca?_t=ZM-8zkvMAkZ5QT&_r=1" class="footer-icon"      target="_blank" >
      <i :class="['bi', 'bi-tiktok', 'me-2']"></i>
    </a>
   
   
  </div>
</div>

      </div>

      <!-- Copyright -->
      <div class="text-center mt-4 text-light small fade-in" style="animation-delay: 0.6s;">
        &copy; 2025 Victoria Gym. Todos los derechos reservados.
      </div>
    </div>
  </footer>
</template>

<script setup>
// Importa Bootstrap Icons si no lo tienes en main.js
import 'bootstrap-icons/font/bootstrap-icons.css'
</script>

<style scoped>
.footer {
  background-color: #1f1f1f;
  color: #fff;
  font-family: 'Poppins', sans-serif;
}

/* Logo */
.footer-logo-img {
  width: 150px;
  display: block;
  margin-bottom: 0.5rem;
}

/* Slogan */
.footer-slogan {
  color: #FBBF24;
  font-weight: 500;
  font-size: 0.95rem;
}

/* Título */
.footer-title {
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #FBBF24;
}

/* Enlaces */
.footer-link {
  display: block;
  color: #fff;
  text-decoration: none;
  margin-bottom: 0.3rem;
  transition: color 0.3s;
}
.footer-link:hover {
  color: #F97316;
}

/* Redes sociales */
.footer-icons a {
  display: inline-block;
  margin-right: 0.5rem;
  font-size: 1.6rem;
  color: #fff;
  transition: transform 0.3s, color 0.3s;
}
.footer-icons a:hover {
  transform: translateY(-3px) scale(1.1);
  color: #F97316;
}

/* Copyright */
.text-light {
  color: rgba(255, 255, 255, 0.8);
}

/* Animaciones */
.fade-in {
  opacity: 0;
  transform: translateY(10px);
  animation: fadeInUp 0.8s forwards;
}
@keyframes fadeInUp {
  to { opacity: 1; transform: translateY(0); }
}

/* Responsive */
@media (max-width: 768px) {
  .footer-logo-img, .footer-title, .footer-slogan {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }
  .footer-icons {
    text-align: center;
    margin-top: 0.5rem;
  }
}
</style>
